/* eslint-disable no-use-before-define */
import React from 'react'
import { isEmpty } from '../twd'
import { useCalculator } from './use-calculator'

export const CantCalc = () => {
    const {
        bondInfo, 
    } = useCalculator()

    if (isEmpty(bondInfo)) return null

    return  <React.Fragment>
        {!bondInfo.canCalc && 
            <div className="row vertical-offset-base">
            <div className="col-md-12 col-xs-12 text-center">
                <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
                <p>Calculations are not supported for this bond. 
                Please call our Fixed Income Specialists at 877-355-3237 with inquiries or for support placing orders                                
                </p>
            </div>                
            </div>}
        </React.Fragment>

}




// WEBPACK FOOTER //
// ./src/calculator/cant-calc.js